import { AccountCard } from "@/components/common/account-card";
import { useI18nNavigate } from "@/hooks/use-i18n-navigate";

interface UserInfoProps {
  username: string;
  email: string;
  avatar?: string;
  onClick?: () => void;
}

export function UserInfo({ username, email, avatar, onClick }: UserInfoProps) {
  const navigate = useI18nNavigate();

  return (
    <div
      className="px-2 py-1.5 cursor-pointer"
      onClick={onClick || (() => navigate("/settings/account/"))}
    >
      <AccountCard name={username} email={email} avatar={avatar} />
    </div>
  );
}